import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useComponentProps, useEffectEvent} from 'helpers/hooks/utils';
import StyledEntitiesBrowserList from 'components/organisms/Browsers/EntitiesBrowserList/EntitiesBrowserList.styles';
import {useTable} from 'components/organisms/Providers/TableProvider/TableProvider';
import utils from 'helpers/utils';

const EntitiesBrowserList = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps({
    showControls: false,
    color: 'primary',
    ...props
  }, 'EntitiesBrowserList');

  const [items, setItems] = useState([]);

  const tableProvider = useTable();
  const selectedEntity = tableProvider.selected();

  const nextEvent = useEffectEvent(tableProvider.next);
  const prevEvent = useEffectEvent(tableProvider.prev);
  useEffect(() => {
    if (selectedEntity) {
      const nextItems = utils.toArray(nextEvent?.(2));
      const prevItems = utils.toArray(prevEvent?.(2));

      setItems(prevItems.filter((e) => {
        return +e.entityId !== +selectedEntity.entityId &&
          !nextItems.find((ep) => +ep.entityId === +e.entityId);
      })
        .concat([selectedEntity])
        .concat(nextItems.filter((e) => +e.entityId !== +selectedEntity.entityId))
        .map((entity) => ({
          id: entity.entityId,
          url: entity.website,
          screenshots: entity.websiteScreenshots
        })));
    }
  }, [selectedEntity, prevEvent, nextEvent]);

  return <StyledEntitiesBrowserList ref={ref} {...innerProps} items={items} selectedId={selectedEntity?.entityId}/>
});

EntitiesBrowserList.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  items: PropTypes.array,
  selected: PropTypes.object,
  BrowserProps: PropTypes.object
};

export default EntitiesBrowserList;
